import { Model } from 'modules/core/lib/mobx-rest'

export interface IApiKey {
  id: string
  created_at: string
  name: string
  token: string | null
}

class ApiKey extends Model<IApiKey> {
  static urlRoot() {
    return '/api_keys'
  }
}

export default ApiKey
